import React from 'react'
import { useStartpageBlocks } from '@hooks/useStartpageBlocks'
import { useLibraryBooks } from '@hooks/useLibraryBooks'
import { useLibrarySections } from '@hooks/useLibrarySections'
import Loader from '@components/Loader'
import Text from '@components/Text'
import { DIVIDER_SIZE, STARTPAGE_BLOCK_TYPES } from '@helpers/constants'
import NewBooks from './NewBooks'
import NewSections from './NewSections'
import FeaturedBook from './FeaturedBook'
import FeaturedSection from './FeaturedSection'
import FeaturedBooksGroup from './FeaturedBooksGroup'
import FeaturedSectionsGroup from './FeaturedSectionsGroup'
import Divider from '@components/Divider'

const StartpageBlocks = (props) => {
  const { startpageBlocks, error, isLoading } = useStartpageBlocks()

  const { books: newBooks } = useLibraryBooks()
  const { sections: newSections } = useLibrarySections()

  return (
    <>
      {isLoading && <Loader />}

      {error && <Text>Något gick fel när innehållet skulle hämtas.</Text>}

      {!isLoading && !startpageBlocks.length > 0 && (
        <>{/* <Text>Inget innehåll på startsidan</Text> */}</>
      )}

      {!isLoading && !error && startpageBlocks.length > 0 && (
        <>
          {/* <Divider size={DIVIDER_SIZE.MEDIUM} /> */}

          {startpageBlocks.map((block, index) => {
            const { id, blockType, heading, text, books, sections } = block
            const reversed = index % 2

            const nextBlock = startpageBlocks[index + 1]

            const getDivider = () => {
              if (
                blockType === STARTPAGE_BLOCK_TYPES.NEW_BOOKS ||
                blockType === STARTPAGE_BLOCK_TYPES.NEW_SECTIONS ||
                blockType === STARTPAGE_BLOCK_TYPES.FEATURED_BOOKS_GROUP ||
                blockType === STARTPAGE_BLOCK_TYPES.FEATURED_SECTIONS_GROUP
              ) {
                if (
                  nextBlock?.blockType === STARTPAGE_BLOCK_TYPES.FEATURED_BOOK
                ) {
                  return <Divider size={DIVIDER_SIZE.XLARGE} />
                } else {
                  return <Divider size={DIVIDER_SIZE.LARGE} />
                }
              } else if (
                blockType === STARTPAGE_BLOCK_TYPES.FEATURED_BOOK ||
                blockType === STARTPAGE_BLOCK_TYPES.FEATURED_SECTION
              ) {
                if (
                  nextBlock?.blockType === STARTPAGE_BLOCK_TYPES.NEW_BOOKS ||
                  nextBlock?.blockType === STARTPAGE_BLOCK_TYPES.NEW_SECTIONS ||
                  nextBlock?.blockType ===
                    STARTPAGE_BLOCK_TYPES.FEATURED_BOOKS_GROUP ||
                  nextBlock?.blockType ===
                    STARTPAGE_BLOCK_TYPES.FEATURED_SECTIONS_GROUP
                ) {
                  return <Divider size={DIVIDER_SIZE.LARGE} />
                }
              }
            }

            return (
              <div key={id}>
                {blockType === STARTPAGE_BLOCK_TYPES.NEW_BOOKS &&
                  newBooks.length > 0 && (
                    <>
                      <NewBooks
                        heading={heading}
                        text={text}
                        books={newBooks}
                      />
                      {getDivider()}
                    </>
                  )}

                {blockType === STARTPAGE_BLOCK_TYPES.NEW_SECTIONS &&
                  newSections.length > 0 && (
                    <>
                      <NewSections
                        heading={heading}
                        text={text}
                        sections={newSections}
                      />
                      {getDivider()}
                    </>
                  )}

                {blockType === STARTPAGE_BLOCK_TYPES.FEATURED_BOOK &&
                  books.length > 0 && (
                    <>
                      <FeaturedBook
                        heading={heading}
                        text={text}
                        book={books[0]}
                        reversed={reversed ? true : false}
                      />
                      {getDivider()}
                    </>
                  )}

                {blockType === STARTPAGE_BLOCK_TYPES.FEATURED_SECTION &&
                  sections.length > 0 && (
                    <>
                      <FeaturedSection
                        heading={heading}
                        text={text}
                        section={sections[0]}
                        reversed={reversed ? true : false}
                      />
                      {getDivider()}
                    </>
                  )}

                {blockType === STARTPAGE_BLOCK_TYPES.FEATURED_BOOKS_GROUP &&
                  books.length > 0 && (
                    <>
                      <FeaturedBooksGroup
                        heading={heading}
                        text={text}
                        books={books}
                      />
                      {getDivider()}
                    </>
                  )}

                {blockType === STARTPAGE_BLOCK_TYPES.FEATURED_SECTIONS_GROUP &&
                  sections.length > 0 && (
                    <>
                      <FeaturedSectionsGroup
                        heading={heading}
                        text={text}
                        sections={sections}
                      />
                      {getDivider()}
                    </>
                  )}
              </div>
            )
          })}
        </>
      )}
    </>
  )
}

export default StartpageBlocks
